//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {CollapseTransition} from "@ivanv/vue-collapse-transition";
import vuescroll from 'vuescroll/dist/vuescroll-native';
import MobileSlider from "./MobileSlider.vue";

export default {
  components: {
    MobileSlider,
    CollapseTransition,
    vuescroll
  },
  data() {
    return {
      isMounted: false,
      boardOfDirectors: {
        isOpened: false,
        sectionId: "boardOfDirectors",
        items: [
          {id:0},
          {id:1},
          {id:2},
          {id:3},
          {id:4},
        ]
      },
      topManagement: {
        isOpened: false,
        sectionId: "topManagement",
        items: [
          {
            id: 0,
            img: 'gorkov.jpg'
          },
          {
            id: 1,
            img: 'gulidin.jpg'
          },
          {
            id: 2,
            img: 'matushin.jpg'
          },
          {
            id: 3,
            img: 'poslavskaya.jpg'
          },
          {
            id: 4,
            img: 'perevolotsky.jpg'
          },
          {
            id: 5,
            img: 'komleva.jpg'
          },
          {
            id: 6,
            img: 'zaharov.jpg'
          },
          {
            id: 7,
            img: 'saed.jpg'
          },
          {
            id: 8,
            img: 'moldovan.jpg'
          },
        ]
      },
      hoverTimeout: null
    }
  },
  computed: {
    descHeight() {
      return (id) => {
        if(!this.isMounted) {
          return {};
        }
        if (this.$refs.hasOwnProperty(`itemContainer${id}`) && this.$refs.hasOwnProperty(`itemDesc${id}`) && this.$mq !== 'mobile') {
          const itemContainer = this.$refs[`itemContainer${id}`];
          const itemPerson = this.$refs[`itemPerson${id}`];
          const calculated = itemContainer.offsetHeight - itemPerson.offsetHeight;
          if (calculated > 0) {
            return {
              height: `${calculated}px`,
            }
          }
        }

        return {};
      }
    }
  },
  mounted() {
    this.isMounted = true;
    window.addEventListener('resize', () => {
      this.$forceUpdate();
    });

    this.topManagement.items.forEach((element, key) => {
      this.$set(element, 'isHovered', false);
    });
  },
  methods: {
    openSection(sectionName) {
      let section;
      if (sectionName === 'boardOfDirectors') {
        section = this.boardOfDirectors;
      } else {
        section = this.topManagement;
      }

      if (section) {
        section.isOpened = true;

        this.$nextTick(() => {
          const sectionDomElement = document.getElementById(section.sectionId);
          if (sectionDomElement) {
            setTimeout(() => {
              this.$store.dispatch('scrollToElement', {
                element: sectionDomElement,
                duration: 600
              })
            }, 800);
          }
        });
      }
    },
    onDirectorEnter(director) {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
      }
      director.isHovered = true;
    },
    onDirectorLeave(director) {
      this.hoverTimeout = setTimeout(() => {
        director.isHovered = false;
      }, 600);
    }
  }
};
